export default class TableSettings {
  public pagination!:{ current:number, pageSize:number }
  public showSizeChanger!:boolean
  public pageSizeOptions!:string[]
  public activeFilters!:Record<string, (string|number|boolean)[]>
  public archiveConditions:{[key: string]: number[]|string[]}
  public sort:{ columnKey: string; order: string } | null
  public search: string
  public archived? = false
  public unrelated? = false
  public createdAtPeriod?: { from: string|null, to: string|null }|null

  constructor (conditions:{[key: string]: number[]|string[]}, sort?:{column:string, order:string}) {
    this.pagination = { current: 1, pageSize: 25 }
    this.showSizeChanger = true
    this.pageSizeOptions = ['25', '50', '100', '250']
    this.activeFilters = { '': [] }
    this.archiveConditions = conditions
    this.archived = false
    this.unrelated = false
    this.search = ''
    this.createdAtPeriod = null

    if (sort !== undefined) {
      this.sort = {
        columnKey: sort?.column || 'created_at',
        order: sort?.order || 'descend'
      }
    } else {
      this.sort = null
    }
  }

  static from (raw: any, conditions: {[key: string]: number[]|string[]}, sort?:{column:string, order:string}): TableSettings {
    const inst = new TableSettings(conditions, sort)
    if (!raw || typeof raw !== 'object') return inst
    const knownKeys = Object.keys(inst) as (keyof TableSettings)[]
    for (const k of knownKeys) {
      if (raw[k] !== undefined) (inst as any)[k] = raw[k]
    }
    return inst
  }
}
